import React, {
  Fragment,
  useState,
  useEffect,
  useRef,
  useMemo,
  useCallback,
} from "react";
import {
  getMlmfoutletMaster,
  getoutletListMaster,
  getCompanyListMaster,
  getDeliveryslotListMaster,
  getTemplatemsgMaster,
  getOutletListMaster,
  AprovalpointREQ,
} from "../../../../apiservicescall/api";
import Table from "@mui/material/Table";
import { MuiThemeProvider, createMuiTheme } from "@material-ui/core/styles";
import MUIDataTable from "mui-datatables";
import Stepper from "@material-ui/core/Stepper";
import Step from "@material-ui/core/Step";
import StepLabel from "@material-ui/core/Step";
import StepButton from "@material-ui/core/StepButton";
import RctCollapsibleCard from "../RctCollapsibleCard/RctCollapsibleCard";
import {
  // Table,
  Badge,
  Row,
  Card,
  Col,
  Button,
  Container,
  ListGroup,
  Tab,
} from "react-bootstrap";
import { Link } from "react-router-dom";
import Select from "react-select";

import {
  Pagination,
  PaginationItem,
  PaginationLink,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap";
import swal from "sweetalert";
import { Form, FormGroup, Label, Input } from "reactstrap";
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { Edit, Height } from "@material-ui/icons";
import TemplateService from "./TemplateService";
import {
  // Stepper,
  // Step,
  // StepLabel,
  Typography,
  TextField,
  FormControl,
  InputLabel,
  MenuItem,
  CardContent,
  List,
} from "@mui/material";

import card from "./Card.css";

const TemplateServiceList = () => {
  const [restarantvalue, setRestarantvalue] = useState([
    { label: "", value: "" },
  ]);
  const [outletMasterlist, setOutletMasterlist] = useState([]);
  const [companyMaster, setCompanyMaster] = useState([]);
  const [outletvalue, setOutletvalue] = useState([{ label: "", value: "" }]);

  const [deliverySlot, setDeliverySlot] = useState([]);
  const [list, setList] = useState([]);
  const [rowData, setRowData] = useState([
    {
      footer: "",
      header: "",
      id: "",
      message: "",
      messageBody: "",
      templateName: "",
      templateId: "",
      approvalFlag: { label: "", value: "" },
      status: "",
      language: "",
      outletId: "",
      outletName: "",
      headerTypeName: "",
      headerUrl: "",
    },
  ]);
  const [view, setView] = useState(false);
  const [edit, setEdit] = useState(false);
  const [status, setStatus] = useState("");
  const [approval, setApproval] = useState([
    // { label: "Pending", value: "P" },
    { label: "Approved", value: "A" },
    { label: "Rejected", value: "R" },
  ]);

  let [errors, setErrors] = useState({
    approvalFlag: null,
  });
  let [formIsValid, setFormIsValid] = useState(false);

  const [appEdit, setAppEdit] = useState({
    templateName: "",
    templateId: 0,
    approvalFlag: "",
  });
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [totalItems, setTotalItems] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [approvalpopup, setApprovalPopup] = useState(false);

  useEffect(() => {
    getcompanyMasterList();
    getwhatsappMsgTemplist();
  }, []);

  const getcompanyMasterList = async () => {
    let getoutletList = await getCompanyListMaster();
    let getoutletListValue = getoutletList?.data?.data || [];
    let companyoutmaster = getoutletListValue.map(({ compCode, compName }) => ({
      label: compName,
      value: compCode,
    }));

    getoutletMasterList(getoutletListValue[0]?.compCode);
  };

  const getoutletMasterList = async (companyCode) => {
    let getoutletList = await getoutletListMaster(companyCode);
    let getoutletListValue = getoutletList?.data?.data;
    let companyoutmaster =
      getoutletListValue &&
      getoutletListValue.length > 0 &&
      getoutletListValue.map(({ outletCode, outletName }) => ({
        label: `${outletCode}-${outletName}`,
        value: outletCode,
      }));
    // console.log("companyoutmaster", companyoutmaster);
    setOutletMasterlist(companyoutmaster);
  };

  const getOutletBasedList = async () => {
    let outletId = restarantvalue.value;
    console.log("outletId", outletId);
    let getDplanList = await getOutletListMaster(outletId);
    console.log("getDplanList :>> ", getDplanList);
    let getListValue = getDplanList?.data?.data || [];
    setList(getListValue);
  };

  const getwhatsappMsgTemplist = async () => {
    let getlist = await getTemplatemsgMaster();

    let getlistvalue = getlist?.data.data || [];
    console.log("getlistvalue", getlistvalue);

    setList(getlistvalue);
  };

  const onClose = () => {
    setView(!view);
    setEdit(false);
  };
  const onEditClose = () => {
    setEdit(false);
    setView(false);
  };

  const onEdit = (item) => {
    console.log("item", item);
    setRowData({
      footer: item.footer,
      header: item.header,
      id: item.id,
      message: item.message,
      messageBody: item.messageBody,
      name: item.name,
    });

    setEdit(true);
    setView(false);
  };

  const viewDpoint = (data) => {
    let selectedUser = list.find((value, index) => index == data?.rowIndex);
    console.log("selectedUser", selectedUser);
    setView(true);
    setRowData({
      templateName: selectedUser?.templateName,
      templateId: selectedUser?.templateId,
      approvalFlag: selectedUser?.approvalFlag,

      header: selectedUser.headerText,
      outletId: selectedUser.outletId,
      messageBody: selectedUser.body,
      language: selectedUser.languageName,
      status: "",
      footer: selectedUser.footer,
      outletName: selectedUser.outletName,
      headerTypeName: selectedUser.headerTypeName,
      headerUrl: selectedUser.headerUrl,
    });
  };

  const onViewClose = () => {
    setView(false);
  };

  const onApprovalClose = () => {
    setApprovalPopup(false);
    setAppEdit({});
    setFormIsValid(false);
  };

  //Approval flag declaration part

  const approvalcall = (data) => {
    let selectedUser = list.find((value, index) => index === data?.rowIndex);

    // console.log("selectedUser", selectedUser);

    setAppEdit({
      templateName: selectedUser?.templateName,
      templateId: selectedUser?.templateId,
      approvalFlag: selectedUser?.approvalFlag,
    });
    setApprovalPopup(true);
  };

  const ApprovalupdateAPI = async () => {
    let tempId = appEdit.templateId;
    let aproflag = appEdit.approvalFlag.value;

    console.log("tempId  aproflag :>> ", tempId, aproflag);

    // return false;

    let reqfordeliverypoint = await AprovalpointREQ(tempId, aproflag);

    console.log("reqfordeliverypoint", reqfordeliverypoint);
    // return false;
    if (reqfordeliverypoint.data.status === true) {
      setApprovalPopup(false);
      swal("Success!", "Update successfully", "success");
    } else {
      setApprovalPopup(false);
      swal("Oops", `${reqfordeliverypoint.data.message}`, "error");
    }
    setFormIsValid(false);
    getcompanyMasterList();
    getwhatsappMsgTemplist();
  };

  const onChangeCommonpopup = (key, value) => {
    let addFieldValue = {};
    let errorsLocal = { ...errors };
    let formIsValidLocal;

    if (key === "approvalFlag") {
      if (appEdit.approvalFlag !== "P" && appEdit.approvalFlag !== null) {
        console.log(
          "Modification not allowed for Approved or Rejected statuses."
        );
        alert("Changes are not allowed for Approved or Rejected statuses.");
        return; // Exit the function if the condition is met
      }
      // else if (!stringwithnumberPattern.test(value)) {
      //   addFieldValue = { [key]: null };
      //   errorsLocal["itemName"] = "Invalid";
      //   setErrors(errorsLocal);
      //   formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
      //   setFormIsValid(formIsValidLocal);
      // }
      if (!value) {
        addFieldValue = { [key]: null };
        console.log("addFieldValue :>> ", addFieldValue);
        errorsLocal["approvalFlag"] = "Approval flag Required";
        setErrors(errorsLocal);
        setFormIsValid(formIsValidLocal);
      } else {
        addFieldValue = { [key]: value };
        errorsLocal["approvalFlag"] = "";
        setErrors(errorsLocal);
        formIsValidLocal = Object.values(errorsLocal).every((o) => o === "");
        console.log("formIsValidLocal 2222 :>> ", formIsValidLocal);
        setFormIsValid(formIsValidLocal);
      }
    }

    const newFormData = { ...appEdit };
    newFormData[key] = value;
    setAppEdit(newFormData);
  };

  let actionOption = {
    name: "actions",
    label: "Actions",
    options: {
      filter: false,
      sort: false,
      customBodyRender: (summary, tableMeta, updateValue) => {
        return (
          <div className="list-action">
            <span
              style={{ color: "white", display: "flex" }}
              className="icon-top-left"
            >
              {/* <button
              type="button"
              className="rct-link-btn edit-btn"
              onClick={() => onEditUser(tableMeta)}
            >
              <i style={{ fontSize: "15px" }} className="ti-pencil"></i>
            </button> */}

              <Link
                className=""
                onClick={() => {
                  // setOutletDetails({})
                  approvalcall(tableMeta);
                }}
                // style={{ background: "#008000" }}
              >
                <i
                  className="bi bi-check fa-lg tpen-bck"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    marginLeft: "1px",
                  }}
                ></i>
              </Link>

              <Link
                className=""
                onClick={() => {
                  // setOutletDetails({})
                  viewDpoint(tableMeta);
                }}
                // style={{ background: "#008000" }}
              >
                <i
                  className="fa fa-eye tpen-bck"
                  style={{ marginLeft: "3px" }}
                ></i>
              </Link>
            </span>

            {/* <span style={{ paddingLeft: "20px",marginTop: "-20px" }} className="icon-top-left">

            <Link className="btn btn-primary shadow btn-xs sharp me-2"
              onClick={() => viewUser(tableMeta)} style={{ background: "#008000" }}
            >
              <i className="fa fa-eye"></i>
            </Link>
          </span> */}
          </div>
        );
      },
    },
  };

  const handleChangePage = (event, newPage) => {
    setCurrentPage(newPage);
  };

  const onChangeRowsPerPage = (numOfRows) => {
    // let { currentPage, itemsPerPage } = this.state;
    setItemsPerPage(numOfRows);
  };

  const columns = [
    {
      name: "templateName",
      label: "Template Name",
      options: {
        filter: true,
        searchable: true,
        sort: true,
        fixedHeader: true,
        responsive: "stacked",
      },
    },

    {
      name: "templateId",
      label: "Template ID",
      options: {
        filter: true,
        sort: true,
        searchable: true,
        fixedHeader: true,
        responsive: "stacked",
        filterType: "textField",
      },
    },

    {
      name: "outletName",
      label: "Restaurant",
      options: {
        filter: true,
        sort: true,
        searchable: true,
        fixedHeader: true,
        responsive: "stacked",
      },
    },

    {
      name: "headerText",
      label: "Header ",
      options: {
        filter: true,
        sort: true,
        searchable: true,
        customFilterListOptions: { render: (v) => `UID: ${v}` },
        fixedHeader: true,
        responsive: "stacked",
        filterType: "textField",
      },
    },
    {
      name: "approvalFlag",
      label: "Approval Flag",
      options: {
        filter: true,
        sort: true,
        searchable: true,
        fixedHeader: true,
        responsive: "stacked",
        filterOptions: {
          names: ["Approved", "Pending", "Rejected"],
          logic(approvalFlag, filters) {
            const statusMap = { Approved: "A", Pending: "P", Rejected: "R" };
            if (filters.length === 0) {
              return false;
            }
            return !filters.some(
              (filter) => statusMap[filter] === approvalFlag
            );
          },
        },
        customBodyRender: (approvalFlag) => {
          const statusMap = { A: "Approved", P: "Pending", R: "Rejected" };
          return <span>{statusMap[approvalFlag] || "Unknown"}</span>;
        },
      },
    },

    actionOption,
  ];
  const options = {
    filter: true, 
    search: true, 
    // customSearchRender: (searchText, handleSearch, hideSearch, options) => {
    //   return (
    //     <TextField
    //       className="m_2"
    //       value={searchText}
    //       onChange={(e) => handleSearch(e.target.value)}
    //       style={{ color: "red", fontWeight: "bold" }} // Add your styles here
    //       autoFocus={true}
    //       placeholder="Search..."
    //       id="searchField"
    //     />
    //   );
    // },
    selectableRows: false,
    responsive: "stacked",
    fixedHeader: true,
    tableBodyHeight: "51vh",
    fixedSelectColumn: true,
    page: currentPage,
    pagination: true,
    serverSide: false,
    rowsPerPage: itemsPerPage,
    rowsPerPageOptions: [10, 15, 100],
    onChangePage: (newPage) => {
      handleChangePage(newPage);
    },
    onChangeRowsPerPage: (numOfRows) => {
      onChangeRowsPerPage(numOfRows);
    },
    download: false,
    print: false,
    onFilterChange: (
      column,
      filterList,
      type,
      filterOptions,
      changedColumnIndex
    ) => {
      // Handle filter change here
      // You can update state or perform any other action based on the new filterList
    },
    confirmFilters: true,
    customFilterDialogFooter: (currentFilterList, applyNewFilters) => {
      return (
        <div style={{ marginTop: "40px" }}>
          <Button
            variant="contained"
            onClick={() => applyNewFilters()} // Call applyNewFilters to apply filters
          >
            Apply Filters
          </Button>
        </div>
      );
    },
    onFilterConfirm: (filterList) => {
      // Handle filter confirmation here if needed
    },
    onFilterDialogOpen: () => {
      // Handle filter dialog open event if needed
    },
    onFilterDialogClose: () => {
      // Handle filter dialog close event if needed
    },
    customToolbar: () => {
      return (
        <>
          {/* //   {largeModal ? ( */}
          {/* //     <a */}
          {/* //       href="#"
              //       style={{ backgroundColor: "#008000", color: "white" }}
              //       onClick={(e) => opnAddNewUserModal(e)}
              //       className="caret btn-sm mr-10"
              //     >
              //       ADD <i className="zmdi zmdi-lus"></i>
              //     </a> */}
          {/* //   ) : (
              //     <a */}
          {/* //       href="#"
              //       style={{ */}
          {/* //         backgroundColor: "#008000",
              //         color: "white",
              //         fontSize: "medium",
              //       }}
              //       onClick={(e) => { */}
          {/* //         opnAddNewUserModal(e);
              //         setCustomerDetail({});
              //       }}
              //       className="caret btn-sm mr-10"
              //     >
              //       Add <i className="zmdi zmdi-lus"></i>
              //     </a> */}
          {/*  )} */}
        </>
      );
    },
  };
  // Inside the return statement of the TemplateServiceList component
  <MUIDataTable
    title={""}
    data={list}
    columns={columns}
    options={options}
    className={"MuiTabCusCls"}
  />;

  const themeTable = createMuiTheme({
    overrides: {
      MUIDataTable: {
        root: {
          backgroundColor: "#FF000",
        },
        paper: {
          boxShadow: "none",
        },
      },
      MuiTableRow: {
        root: {
          "&:nth-of-type(odd)": {
            backgroundColor: "white !important",
          },
          "&:nth-of-type(even)": {
            backgroundColor: "#e4e8ef !important",
          },
        },
      },

      MUIDataTableHeadCell: {
        root: {
          backgroundColor: "#008000 !important",
        },
        data: {
          fontWeight: "bold",
          color: "white",
          fontSize: "14px",
        },
      },
    },
  });
  function renderApprovalFlag(approvalFlag) {
    let result;
    switch (approvalFlag) {
      case "P":
        result = "Pending";
        break;
      case "A":
        result = "Approved";
        break;
      case "R":
        result = "Rejected";
        break;
      default:
        result = "Unknown";
    }
    return result;
  }

  return (
    <>
      <div className="row">
        <div className="col-md-12 col-lg-12 col-sm-12 col-xl-12 temp-crd">
          <Card>
            <div class="row ovrl-crd-hd-temp">
              <div class="col-3 col-md-3 col-lg-3 ">
                <div class="form-group">
                  <h3 className="main-hd cs-main-hd">Template List</h3>
                </div>
              </div>
              <div
                class="col-9 col-md-9 col-lg-9 row"
                style={{ marginTop: "11px" }}
              >
                <Card.Header className="card-title main-card temp-hd-obj">
                  <div
                    class="col-4 col-md-4 col-lg-4 form-group main-frm-grp"
                    style={{ marginTop: "25px", zIndex: "122" }}
                  >
                    <label
                      className="mb-0"
                      as="a"
                      variant="badge badge-rounded badge-danger"
                    >
                      Restaurant
                    </label>
                    <Select
                      options={outletMasterlist}
                      value={restarantvalue}
                      closeMenuOnSelect={true}
                      styles={{ marginLeft: "100%" }}
                      // search
                      // name="stateCode"
                      placeholder="Choose Restaurant"
                      // autoComplete="off"
                      onChange={(event) => {
                        setRestarantvalue(event);
                      }}
                    />
                  </div>

                  <div
                    class=" col-2 col-md-2 col-lg-2 mt-5 mb-1 form-group"
                    style={{ width: "9.333333%" }}
                  >
                    {/* {selectedusers.value && selectedrestarant.value && */}

                    <Button
                      className="mt-2 btn-primary mn-hd-gt-btn"
                      variant="success dark btn-sm "
                      // disabled={restarantvalue.value == ""}
                      style={{
                        backgroundColor: "green",
                        borderRadius: "2px",
                        border: "0px solid",
                      }}
                      onClick={() => {
                        // getDeliveryslotMenuList();
                        getOutletBasedList();
                      }}
                    >
                      <i
                        // class="fas fa-plus"
                        onClick={() => {}}
                      >
                        Get{" "}
                      </i>{" "}
                    </Button>

                    {/* } */}
                  </div>

                  <div
                    class=" col-2 col-md-2 col-lg-2 mt-5 mb-1  form-group"
                    style={{ width: "9.333333%", marginLeft: "-20px" }}
                  >
                    {/* {selectedusers.value && selectedrestarant.value && */}

                    <Button
                      className="mt-2 btn-primary mn-hd-gt-clr"
                      variant="success dark btn-sm "
                      // disabled={restarantvalue.value == ""}
                      style={{
                        backgroundColor: "red",
                        borderRadius: "2px",
                        border: "0px solid",
                      }}
                      onClick={() => {
                        // getDeliveryslotMenuList();
                        getwhatsappMsgTemplist();
                        setRestarantvalue({});
                      }}
                    >
                      <i
                        // class="fas fa-plus"
                        onClick={() => {}}
                      >
                        Clear{" "}
                      </i>{" "}
                    </Button>

                    {/* } */}
                  </div>
                </Card.Header>
              </div>
            </div>
            {list && list.length > 0 && (
              <RctCollapsibleCard fullBlock>
                <RctCollapsibleCard fullBlock>
                  <MuiThemeProvider theme={themeTable}>
                    <MUIDataTable
                      title={""}
                      data={list}
                      columns={columns}
                      options={options}
                      columOrder={columns}
                      className={"MuiTabCusCls"}
                    />
                  </MuiThemeProvider>
                </RctCollapsibleCard>
              </RctCollapsibleCard>
            )}

            {/* <Card.Body
              className="scroll-tbl-fix-heade tab-hd-clr"
              style={{ padding: "3px" }}
            >
              <Table responsive stripped>
                <thead style={{backgroundColor:"#0f590f !important"}}>
                  <tr>
                    <th>Template Name</th>
                    <th>Restaurant </th>
                    <th>Header </th>
                    <th> Approval Status </th>
                    {/* <th>Approval Flag </th> */}

            {/* <th>Action </th>
            //       </tr>
            //     </thead>
            //     {
            //       <tbody>
            //         {list &&
            //           list.map((items) => {
            //             return (
            //               <tr>
            //                 <td>{items.templateName}</td>

            //                 <td>{items.outletName}</td>
            //                 <td>{items.headerText}</td>
            //                 <td>{items.approvalFlag}</td>

            //                 <td style={{display:"flex"}}>
            //                   <i
            //                     onClick={() => {
            //                       approvalcall(items);
            //                     }}
            //                     style={{ fontSize: "large" }}
            //                     className="ti-pencil tpen-bck"
            //                   ></i>

            //                   <i
            //                     onClick={() => {
            //                       viewDpoint(items);
            //                       console.log("items", items);
            //                     }}
            //                     style={{
            //                       // fontSize: "large",
            //                       // paddingLeft: "15px",
            //                       marginLeft:"2px"
            //                     }}
            //                     className="fa fa-eye tpen-bck"
            //                   ></i>
            //                 </td>
            //               </tr>
            //             );
            //           })}
            //         {list?.length <= 0 ? (
            //           <div style={{ color: "red", textAlign: "center" }}>
            //             {" "}
            //             No Data Found{" "}
            //           </div>
            //         ) : (
            //           setDeliverySlot
            //         )}
            //       </tbody>
            //     }
            //   </Table>
            // </Card.Body> */}

            {/* <Modal
              isOpen={view}
              style={{ maxWidth: "600px" }}
              backdrop="static"
            >
              <div className="tmp-bg-pop-up">
                <ModalHeader
                  className="popup-header"
                  style={{ background: "green", color: "white" }}
                >
                  View
                </ModalHeader>
                <ModalBody>
                  <div className="row">
                    <div className="col-sm-3 col-md-3 col-xl-3 pop-up-tab">
                      <FormGroup>
                        <Label for="templatename">Template Name</Label>
                        <Input
                          type="text"
                          name="templatename"
                          id="templatename"
                          value={rowData.templateName || ""}
                          disabled
                        />
                      </FormGroup>
                    </div>
                    <div className="col-sm-3 col-md-3 col-xl-3 pop-up-tab">
                      <FormGroup>
                        <Label for="templateid">Template Id</Label>
                        <Input
                          type="text"
                          name="templateid"
                          id="templateid"
                          value={rowData?.templateId || ""}
                          disabled
                        />
                      </FormGroup>
                    </div>
                    <div className="col-sm-3 col-md-3 col-xl-3 pop-up-tab">
                      <FormGroup>
                        <label
                          as="a"
                          variant="badge badge-rounded badge-danger"
                        >
                          Approval Flag
                        </label>
                        <Select
                          options={approval}
                          closeMenuOnSelect={true}
                          placeholder="Choose"
                          autoComplete="off"
                          value={
                            approval.find(
                              (option) =>
                                option.value &&
                                rowData.approvalFlag &&
                                option.value.toLowerCase() ===
                                  rowData.approvalFlag.toLowerCase()
                            ) || ""
                          }
                          isDisabled
                        />

                        <span style={{ color: "red" }}>
                          {errors["approvalFlag"]}
                        </span>
                      </FormGroup>
                    </div>

                    {/* Add other input fields as needed 
                  </div>
                </ModalBody>
                <ModalFooter>
                  <Button
                    variant="danger light"
                    onClick={() => {
                      onViewClose(); // Function to close the modal
                    }}
                  >
                    Close
                  </Button>
                </ModalFooter>
              </div>
            </Modal> */}
            <Modal isOpen={view} className="custom-modal" backdrop="static">
              <div className="modal-background">
                <ModalHeader className="modal-header">Preview</ModalHeader>
                <ModalBody>
                  <div className="template-info">
                    {rowData.headerUrl && (
                      <div className="img-info">
                        <img src={rowData.headerUrl} alt="Header Image" />
                      </div>
                    )}
                    <p className="template-name">
                      <strong>Template Name:</strong>{" "}
                      {rowData.templateName || ""}
                    </p>
                    <p className="restaurant-id">
                      <strong>Restaurant ID:</strong> {rowData.outletId || ""}
                    </p>
                    <p className="restaurant-name">
                      <strong>Restaurant Name:</strong>{" "}
                      {rowData.outletName || ""}
                    </p>
                    <p className="header-info">
                      <strong>Header:</strong> {rowData.header || ""}
                    </p>
                    <p className="approval-flag">
                      <strong>Approval Flag:</strong>{" "}
                      {renderApprovalFlag(rowData.approvalFlag)}
                    </p>
                  </div>
                </ModalBody>
                <ModalFooter>
                  <Button variant="danger light" onClick={onViewClose}>
                    Close
                  </Button>
                </ModalFooter>
              </div>
            </Modal>

            <Modal
              isOpen={approvalpopup}
              // toggle={() => onClose()}
              style={{
                // maxWidth: approvalpopup && "700px",
                maxWidth: "600px",
                display: "block",
                margin: "150px auto",
              }}
              backdrop="static"
            >
              <div className="cstm-mdl-hd cstm-mdl-hd-btn">
                <ModalHeader style={{ background: "#008000" }}>
                  {approvalpopup && " Status Update"}
                </ModalHeader>

                <ModalBody>
                  {approvalpopup && (
                    <>
                      <div className="row">
                        <div className="col-sm-3 col-md-3 col-xl-3  pop-up-tab">
                          <FormGroup>
                            <Label for="actualCount ">Template Name</Label>
                            <Input
                              type="templatename"
                              name="templatename"
                              id="templatename"
                              required
                              disabled
                              autoComplete="off"
                              value={appEdit.templateName}
                            />
                          </FormGroup>
                        </div>
                        {/* <div className="col-sm-3 col-md-3 col-xl-3  pop-up-tab">
                          <FormGroup>
                            <Label for="actualCount ">Template Id</Label>
                            <Input
                              type="templatId"
                              name="templatId"
                              id="templatId"
                              required
                              disabled
                              autoComplete="off"
                              value={appEdit.templateId}
                            />
                          </FormGroup>
                        </div> */}

                        <div className="col-sm-3 col-md-3 col-xl-3 ms-4 pop-up-tab ">
                          <FormGroup>
                            <label
                              as="a"
                              variant="badge badge-rounded badge-danger"
                            >
                              Approval Flag
                            </label>
                            <Select
                              options={approval}
                              closeMenuOnSelect={true}
                              placeholder="Choose"
                              autoComplete="off"
                              value={approval.find(
                                (option) =>
                                  option.value === appEdit.approvalFlag
                              )}
                              onChange={(event) => {
                                if (appEdit.approvalFlag !== "P") {
                                  // Prevent change if status is not 'Pending'
                                  alert(
                                    'Changes are not allowed for "Approved" or "Rejected" statuses.'
                                  );
                                  return;
                                }
                                onChangeCommonpopup("approvalFlag", event);
                              }}
                              isDisabled={appEdit.approvalFlag !== "P"} // Disable editing if not 'Pending'
                            />

                            <span style={{ color: "red" }}>
                              {errors["approvalFlag"]}
                            </span>
                          </FormGroup>
                        </div>
                      </div>
                    </>
                  )}
                </ModalBody>

                <ModalFooter>
                  {approvalpopup && (
                    <>
                      <Button
                        variant="success"
                        disabled={!formIsValid}
                        // style={{
                        //   backgroundColor: "#08000",
                        //   marginRight: "40px",
                        // }}
                        className={
                          !formIsValid
                            ? "btn-disabled"
                            : "btn-info text-white me-3 foot-btn-sv"
                        }
                        onClick={() => {
                          ApprovalupdateAPI();
                        }}
                      >
                        Update
                      </Button>
                      <Button
                        className="foot-btn-cls"
                        variant="danger"
                        onClick={() => {
                          onApprovalClose();
                        }}
                      >
                        Cancel
                      </Button>
                    </>
                  )}
                </ModalFooter>
              </div>
            </Modal>
          </Card>
        </div>
      </div>
    </>
  );
};

export default TemplateServiceList;
